import { OfdmaRawIucProfile } from '@models/meter-scans/ofdma/ofdma-raw-iuc-profile';
import { OfdmaPreEqualization } from '@models/meter-scans/ofdma/ofdma-raw-pre-equalization';
import { ClassCast } from '@utilities/object-helper';

export class OfdmaRaw {
    transmitPower: number;
    firstActiveSubcarrierNumber: number;
    subcarrierSpacing: number;
    numSymbolsPerFrame: number;
    ofdmPortId: number;
    @ClassCast(OfdmaRawIucProfile)
    iucProfile: OfdmaRawIucProfile[];
    preequalier: number;
    lastActiveSubcarrierNumber: number;
    cyclicPrefix: number;
    numActiveSubcarrier: number;
    @ClassCast(OfdmaPreEqualization)
    preEq: OfdmaPreEqualization;
    subcarrierZeroFrequency: number;
    rollOffPeriod: number;
}
